import { Container, Title, Text, ThemeIcon, List, Image } from "@mantine/core";
import { IconCheck } from '@tabler/icons-react';

import classes from './HomePage.module.css';
import { Link } from "react-router-dom";
import AppointmentChecker from "./components/AppointmentChecker";

const HomePage = ({ isGeneralClinic = true }: { isGeneralClinic?: boolean}) => {

    const PageTitle = isGeneralClinic ? "General Clinic" : "Behavioral Health";


    return (
        <Container size="md" className={classes.wrapper}>
            <Image src="assets/st_mina.png" className={classes.imageTop} />
            <div className={classes.inner}>
            <div className={classes.content}>
                <Title className={classes.title} style={{ color: 'var(--my-darker)' }}>
                    <span className={classes.highlight}>St. Mina</span> {PageTitle}
                </Title>
                <Text c="var(--my-dark)" mt="md" >
                Registration is a must and no walk-ins are allowed. 
                {isGeneralClinic 
                    ? <><br/>Any questions please call or text - <Link to="tel:813-360-0622">813-360-0622</Link> - Texting preferred. </>
                    : <><br/>Any questions please call or text - <Link to="tel:727-282-4926">727-282-4926</Link> - Texting preferred. </>
                }
                </Text>
    
                <List
                mt={30}
                spacing="sm"
                size="sm"
                icon={
                    <ThemeIcon size={20} radius="xl">
                    <IconCheck size={12} stroke={1.5} />
                    </ThemeIcon>
                }
                >
                    <List.Item>
                        The doctor will see one patient at a time.
                    </List.Item>
                    <List.Item>
                        No family members or children are allowed to come with the patient, except if the patient can not walk without assistance
                    </List.Item>
                    <List.Item>
                        Please be aware that we only see <b>uninsured individuals</b>. If you have insurance, we can't provide you with any service.
                    </List.Item>
                </List>
                
                <AppointmentChecker isGeneralClinic={isGeneralClinic} />
                
            </div>
            <Image src="assets/st_mina.png" className={classes.image} />
            </div>
        </Container>
    );
};

export default HomePage;
